import { Link } from 'react-router-dom'
import Color from 'color'
import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const TitleWrapper = styled.div`
  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.tiny};
    font-family: ${theme.fontFamily.secondary};
    font-size: ${theme.fontSize.mobile.small};
    line-height: ${theme.lineHeight.mobile.small};
  `}

  ${({ theme }) => media.sm`
    font-family: ${theme.fontFamily.secondary};
    font-size: ${theme.fontSize.desktop.small};
    line-height: ${theme.lineHeight.desktop.small};
  `}
`
export const DescriptionWrapper = styled.div`
  transition: color 0.3s ease;

  ${media.sm`
    max-height: 60px;
    overflow: hidden;

    @supports (-webkit-line-clamp: 3) {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  `}
`

export const DeadlineWrapper = styled.div`
  ${({ theme }) => `
    margin-top: ${theme.space.mobile.tiny};
  `}
`
export const ItemLink = styled(Link)`
  display: block;

  &:last-child {
    border-bottom: 0;
  }

  ${({ theme }) => `
    padding: ${theme.space.mobile.small} 0;
    color: ${theme.color.white};
    border-bottom: 1px solid  ${Color(theme.color.white).alpha(0.2).string()};

    &:hover {
      color: ${theme.color.white} !important;

      ${DescriptionWrapper} {
        color: ${theme.color.oceanLight};
      }
    }
  `}
`

export const Deadline = styled.div`
  display: inline-block;
  position: relative;

  ${({ theme }) => `
    background: ${theme.color.gold};
    color: ${theme.color.black};
    padding: ${theme.space.mobile.nano} ${theme.space.mobile.tiny};
    border-radius: ${theme.borderRadius.base};
    font-size: ${theme.fontSize.mobile.tiny};
    
    &:after {
      content: '';
      position: absolute;
      left: 1px;
      top: 100%;
      width: 0;
      height: 0;
      border-top: 7px solid ${theme.color.mustard};
      border-left: 7px solid transparent;
    }
  `}
`

export const DateCreatedWrapper = styled.div`
  display: flex;
  align-items: center;
  opacity: 0.7;

  svg {
    flex-shrink: 0;
    width: 12px;
  }

  span {
    flex: 1 0;
  }

  ${({ theme }) => `
    margin-top: ${theme.space.mobile.small};
    font-size: ${theme.fontSize.mobile.tiny};
    
    svg {
      margin-right: ${theme.space.mobile.nano};
      g {
        stroke: ${theme.color.white};
      }
    }
  `}
`
